import { SimplePdfViewer } from "@/components/shared/file-viewers/simple-pdf-viewer";
import { ErrorMessage } from "@/components/ui/error";
import { LoadingSpinner } from "@/components/ui/spinner";
import { useInvoicePdfCache } from "@/providers/invoice-pdf-cache";
import { useEffect, useState } from "react";

export const InvoiceViewer = ({
  invoiceId,
  toolbar = false,
}: {
  invoiceId: string;
  toolbar?: boolean;
}) => {
  const [pdfBlob, setPdfBlob] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { fetchPdf } = useInvoicePdfCache();

  useEffect(() => {
    const _fetchPdf = async () => {
      try {
        setLoading(true);
        const { blob } = await fetchPdf(invoiceId);
        setPdfBlob(blob);
      } catch (error) {
        setError(error as string);
      } finally {
        setLoading(false);
      }
    };
    _fetchPdf();
  }, [invoiceId, fetchPdf]);

  return (
    <div className="h-full flex flex-col bg-white shadow-lg border rounded-md">
      <div className="p-4 flex-1 overflow-y-auto">
        <div className="h-full w-full">
          {loading && (
            <div className="flex justify-center items-center h-full">
              <LoadingSpinner />
            </div>
          )}
          {error && (
            <div className="flex justify-center items-center h-full">
              <ErrorMessage />
            </div>
          )}
          {pdfBlob && <SimplePdfViewer pdfBlob={pdfBlob} toolbar={toolbar} />}
        </div>
      </div>
    </div>
  );
};
